import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainValidation() {
  return <section className="py-10 md:py-20 bg-white" data-id="element-99">
      <div className="container mx-auto px-4 md:px-6" data-id="element-100">
        <div className="max-w-4xl mx-auto" data-id="element-101">
          <div className="text-center mb-6 md:mb-12" data-id="element-102">
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-103">
              ¿Te sentís identificado con esto?
            </h2>
            <p className="text-sm md:text-lg text-gray-600" data-id="element-104">
              No sos el único. La mayoría de las personas luchan con el desorden
              financiero.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-2 gap-3 md:gap-6" data-id="element-105">
            {['Llegás a fin de mes y no sabés en qué se fue la plata.', 'Tenés deudas que parecen no bajar nunca.', "Querés ahorrar pero siempre surge un 'gasto imprevisto'.", 'Sentís ansiedad cada vez que tenés que revisar tu cuenta.'].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex flex-col md:flex-row items-start gap-2 md:gap-4 p-3 md:p-6 rounded-xl bg-gray-50 border border-gray-200" data-id="element-106">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 flex-shrink-0 md:mt-0.5" data-id="element-107" />
                <p className="text-xs md:text-base text-gray-700 font-medium" data-id="element-108">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}